"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import Icon from "../../graphics/Icon/Icon.js";
import Overlay from "../../layout/Overlay/Overlay.js";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { Button as Button$1, rem } from "@mantine/core";
import { forwardRef } from "react";
import '../../../assets/Button.css';const root = "_root_1vv22_2";
const label = "_label_1vv22_101";
const loader = "_loader_1vv22_105";
const ButtonStyles = {
  root,
  label,
  loader
};
const _Button = forwardRef((props, ref) => {
  const {
    text,
    icon,
    href,
    variant = "default",
    contrast,
    loading,
    target = "_self",
    iconPosition = "right",
    className,
    compact,
    wrap,
    mod,
    fullWidth,
    ...rest
  } = props;
  const iconColor = {
    default: "light",
    light: "dark",
    outline: contrast === "dark" ? "light" : "dark",
    subtle: "light",
    cta: "cta",
    transparent: "light",
    idaforsikringorange: "light"
  };
  return /* @__PURE__ */ jsxs(
    Button$1,
    {
      ...rest,
      ref,
      component: href ? "a" : "button",
      href,
      rightSection: icon && iconPosition === "right" && !loading && /* @__PURE__ */ jsx(Icon, { name: icon, color: iconColor[variant], size: rem("24px") }),
      leftSection: icon && iconPosition === "left" && !loading && /* @__PURE__ */ jsx(Icon, { name: icon, color: iconColor[variant], size: rem("24px") }),
      size: "lg",
      loading,
      target,
      className,
      classNames: ButtonStyles,
      mod: { variant, wrap, contrast, compact, "full-width": fullWidth, ...mod },
      children: [
        variant === "transparent" && /* @__PURE__ */ jsx(Overlay, { color: "#ffffff", opacity: 0.1 }),
        text
      ]
    }
  );
});
_Button.displayName = "Button";
const Button = sharedHandler(_Button);
Button.displayName = _Button.displayName;
export {
  ButtonStyles as B,
  Button as default
};
